namespace HA.Core.HTML {
    export class SelectorHead extends Container {

        protected initialize(data: any) {
            super.initialize(data);
            this.addClass("dsh");
        }
    }
}
